import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M3.46 3.696a11.14 11.14 0 0 1 7.752 0l.788.293.787-.293.236.61-.236-.61a11.14 11.14 0 0 1 7.752 0C21.404 4.018 22 4.813 22 5.727v12.834c0 1.37-1.447 2.202-2.688 1.74a7.62 7.62 0 0 0-5.297 0l-1.764.657A.7.7 0 0 1 12 21a.7.7 0 0 1-.251-.042l-1.764-.657a7.62 7.62 0 0 0-5.297 0C3.448 20.763 2 19.93 2 18.56V5.727c0-.914.596-1.709 1.46-2.031m9.213 15.69.865-.323a9 9 0 0 1 6.25 0c.462.172.866-.163.866-.502V5.727c0-.33-.217-.654-.592-.793a9.78 9.78 0 0 0-6.797 0l-.592.22zM11.327 5.153l-.592-.22a9.78 9.78 0 0 0-6.797 0c-.375.14-.592.463-.592.793v12.834c0 .339.404.674.865.502a9 9 0 0 1 6.25 0l.866.322z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }